import React from 'react';
import { ReactiveList, SelectedFilters } from '@appbaseio/reactivesearch';
import { Grid, withStyles, Button, Container } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import AllFilters from '../components/AllFilters';
import Navigation from '../components/Navigation';

const styles = (theme) => ({
	root: {
		width: '100%',
		backgroundColor: theme.palette.background.paper,
		borderBottom: `1px solid ${theme.palette.grey['100']}`,
	},
	inline: {
		display: 'inline',
	},
	results: {
		backgroundColor: theme.palette.background.paper,
		padding: '10px',
		border: `1px solid ${theme.palette.grey['300']}`,
	},
});

const Platform = (props) => {
	const { classes, history } = props;
	return (
		<>
			<Navigation links={[{ to: '/', title: 'Home' }]} currentLink="Platform" />
			<Grid container spacing={4}>
				<AllFilters />
				<Grid item sm={9} xs={12}>
					<Container style={{ margin: ' 10px 0', paddingLeft: 0 }}>
						<SelectedFilters title="Applied Filters" />
					</Container>
					<ReactiveList
						componentId="result"
						dataField="Critic_Score"
						sortBy="desc"
						pagination
						paginationAt="bottom"
						className={classes.results}
						size={7}
						// loader="Loading Results.."
						showResultStats
						react={{
							and: ['platform', 'year'],
						}}
						// renderItem={item => <div key={item._id}>{item.Name}</div>}
						render={({ data }) => {
							return data.map((item) => {
								return (
									<List key={item._id} className={classes.root}>
										<ListItem alignItems="flex-start">
											<ListItemText
												primary={item.Name}
												secondary={
													<React.Fragment>
														{item.Platform} - {item.Year_of_Release}
													</React.Fragment>
												}
											/>
											<Button
												size="small"
												color="primary"
												onClick={() => history.push(`/game/${item._id}`)}
											>
												See More
											</Button>
										</ListItem>
									</List>
								);
							});
						}}
					/>
				</Grid>
			</Grid>
		</>
	);
};
export default withStyles(styles)(Platform);
